import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import AttachmentList from "../AttachmentList/AttachmentList.vue";
import * as XLSX from 'xlsx';

export default {
  name: "Attachment",
  props: ['tipo', 'index', 'data', 'cambio', 'carga_tipo_emisor'],
  data() {
    return {
      pivote_dolares: 0,
      registros: [],
      msg: "Welcome to Your Vue.js App",
      tempAttachments: [],
      attachments: [],
      folios: -1,
      base64: '',
      src: "",
      num: 0,
      loading: false,
      dropzoneOptions: {
        url: 'No se usa',
        paramName: function () {
          return "file[]";
        },
        maxFilesize: 1024000, // MB
        includeStyling: false,
        previewsContainer: false,
        uploadMultiple: false,
        parallelUploads: 20,
        autoProcessQueue: false,
      }
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
    AttachmentList: AttachmentList
  },
  watch: {

  },
  methods: {
    sliceMe(f) {
      console.log('sliceMe');
      var file = f,
        fr = new FileReader,
        chunkSize = 2097152,
        chunks = Math.ceil(file.size / chunkSize),
        chunk = 0;

      function loadNext() {
        var start, end, blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice;
        start = chunk * chunkSize;
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fr.onload = function () {
          if (++chunk < chunks) {
            loadNext(); // shortcut here
          }
        };
        fr.readAsBinaryString(blobSlice.call(file, start, end));
      }

      loadNext();
    },
    parseXmlToJson(xml) {
      console.log('parseXmlToJson');
      const json = {};
      for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && this.parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
      }
      return json;
    },
    async cambiodemoneda(fecha_emision) {
      console.log('cambiodemoneda');
      let data;
      try {
        let r = await this.$store.state.services.administradorService.GTMTOUSD({ fecha: fecha_emision.split("-").reverse().join("/") });
        let data_cambio_USD_GTM = this.parseXmlToJson(r.data);
        let data = data_cambio_USD_GTM.TipoCambioRangoMonedaResponse.TipoCambioRangoMonedaResult.Vars.Var.compra;
        this.pivote_dolares = data;
      } catch (error) {
        this.$toast.error("No disponible el api del Banco de Guatemala")
        return;
      }
      return data;
    },
    async convertirNumeroASFecha(numeroSerie) {
      const fechaBase = new Date('1899-12-30'); // Fecha base de Excel
      const fecha = new Date(fechaBase.getTime() + (numeroSerie - 1) * 24 * 60 * 60 * 1000);
      fecha.setDate(fecha.getDate() + 2); // Suma dos dias
      return fecha.toLocaleDateString(); // Formatea la fecha como una cadena legible
    },
    async fileAdded(file) {
      console.log('fileAdded', file);
      this.$toast.info("Procesando archivo...")
      this.loading = true;
      this.tempAttachments = [];
      let attachment = {};

      if (file.size <= 30000000) {
        console.log('30000000');
      } else {
        await this.$swal.fire({
          title: 'Vaya! , tu archivo ' + file.name + ' esto tomará varios minutos, no canceles la transacción, gracias por tu paciencia',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        })
      }

      let reader = new FileReader();
      try {
        let self = this;
        reader.onload = (e) => {
          let info = new Uint8Array(e.target.result);
          var workbook = XLSX.read(info, { type: 'array' });
          let sheetName = workbook.SheetNames[0]
          let worksheet = workbook.Sheets[sheetName];
          let datas = XLSX.utils.sheet_to_json(worksheet,  { cellDates: true });
          let fila = 1;
          if (self.tipo === 1) {//FACTURAS EMITIDAS *Ventas
            console.log("Attachment.self.tipo === 1 - paso_2");
            let fecha_solicitada = self.data.fecha;
            fecha_solicitada = fecha_solicitada.split("-");
            let mes = parseInt(fecha_solicitada[1]);
            let mes_declaracion = mes - 1;
            let anio = parseInt(fecha_solicitada[0])
            mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio: " + anio);
            let registro = [];
            let registroErroneos = [];
            try {
              datas.forEach(async x => {
                let fecha_emision = x['Fecha de emisión'] || x['Fecha de emisiÃ³n'];
                fecha_emision = (fecha_emision.split("T"))[0];
                let mes_emision = parseInt((fecha_emision.split("-"))[1]);
                let anio_emision = parseInt((fecha_emision.split("-"))[0]);
                if (mes_emision === mes_declaracion && anio_emision === anio) {
                  let anulado = x["Marca de anulado "]
                  if (anulado == undefined) {
                    anulado = x['Marca de anulado']
                  }
                  let monto = 0;
                  if (x['Moneda'] == 'USD') {
                    await this.cambiodemoneda(fecha_emision);
                    monto = parseFloat(x['Monto (Gran Total)']) * this.pivote_dolares;
                    monto = parseFloat(monto).toFixed(2)
                  } else {
                    monto = x['Monto (Gran Total)']
                  }
                  let petroleo = 0;
                  if (x['Petróleo (monto de este impuesto)'] != undefined) {
                    petroleo = x['Petróleo (monto de este impuesto)'];
                  } else {
                    petroleo = x['PetrÃ³leo (monto de este impuesto)'];
                  }
                  registro.push({
                    fecha_emision: x['Fecha de emisión'] || x['Fecha de emisiÃ³n'],
                    numero_autorizacion: x['Número de Autorización'] || x['NÃºmero de AutorizaciÃ³n'],
                    tipo_dte: x['Tipo de DTE (nombre)'] || x['Tipo de DTE (nombre)'],
                    serie: x['Serie'],
                    numero_dte: x['Número del DTE'] || x['NÃºmero del DTE'],
                    nit_emisor: x['NIT del emisor'],
                    nombre_emisor: x['Nombre completo del emisor'],
                    codigo_establesimiento: x['Código de establecimiento'] || x['CÃ³digo de establecimiento'],
                    nombre_establesimiento: x['Nombre del establecimiento'],
                    nit_receptor: x['ID del receptor'],
                    nombre_receptor: x['Nombre completo del receptor'],
                    nit_certificador: x['NIT del Certificador'],
                    nombre_certificador: x['Nombre completo del Certificador'],
                    moneda: x['Moneda'],
                    monto: monto,
                    anulado: anulado,
                    monto_iva: x['IVA (monto de este impuesto)'],
                    monto_petroleo: petroleo,
                    monto_turismo_hospedaje: x['Turismo Hospedaje (monto de este impuesto)'],
                    monto_turismo_pasajes: x['Turismo Pasajes (monto de este impuesto)'],
                    monto_timbre_prensa: x['Timbre de Prensa (monto de este impuesto)'],
                    monto_bomberos: x['Bomberos (monto de este impuesto)'],
                    monto_tasa_municipal: x['Tasa Municipal (monto de este impuesto)'],
                    monto_bebidas_alcoholicas: x['Bebidas alcohólicas (monto de este impuesto)'] != undefined ? x['Bebidas alcohólicas (monto de este impuesto)'] : x['Bebidas alcohÃ³licas (monto de este impuesto)'],
                    monto_tabaco: x['Tabaco (monto de este impuesto)'],
                    monto_cemento: x['Cemento (monto de este impuesto)'],
                    monto_bebidas_no_alcoholicas: x['Bebidas no Alcohólicas (monto de este impuesto)'] != undefined ? x['Bebidas no Alcohólicas (monto de este impuesto)'] : x['Bebidas no AlcohÃ³licas (monto de este impuesto)'],
                    monto_tarifa_portuaria: x['Tarifa Portuaria (monto de este impuesto)'],
                    fila: fila + 1
                  })
                } else {
                  self.$toast.info("Atención en el archivo " + file.name + ", la fecha de emisión de la factura en la línea " + (fila + 1) + " , no coincide con la fecha del período a presentar", { timeout: 10000, showCloseButtonOnHover: true, })
                  registroErroneos.push(fila);
                }
                fila++;
              });
            } catch (error) {
              registro = [];
              self.$toast.error("Este archivo " + file.name + " no es válido, verifica que no hayan lineas incompletas para la carga de facturas", { timeout: 5000 });
              return;
            }
            if (registroErroneos.length > 0) {
              self.$toast.error("Por favor verifica el archivo " + file.name + " de excel y vuelve a ingresar de nuevo", { timeout: 10000 });
              registro = []
              return;
            } else {
              self.$emit('registro', { registros: registro, tipo: self.tipo, archivo: file });
            }
          } else if (self.tipo === 2) {//RETENCIONES
            console.log('Attachment.self.tipo === 2 - paso_3-iva pc');
            // let date = new Date();
            let fecha_solicitada = self.data.fecha;
            fecha_solicitada = fecha_solicitada.split("-");
            let mes = parseInt(fecha_solicitada[1]);
            // let mes = 1;
            let mes_declaracion = mes - 1;
            let anio = parseInt(fecha_solicitada[0])
            mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio *2: " + anio);
            try {
              let encabezado = {
                periodo_inicio: worksheet.B3.w,
                periodo_fin: worksheet.E3.h,
                // periodo_inicio: "01/12/2021",
                // periodo_fin: "31/12/2021",
                nit_retenido: worksheet.B4.v,
                nombres_contribuyente: (worksheet.D4.h).split(", ")[0],
                apellidos_contribuyente: (worksheet.D4.h).split(", ")[1],
                usuario: worksheet.F4.v,
                total_constancias: parseInt(worksheet.B5.h),
              };
              let dia_inicio = parseInt(encabezado.periodo_inicio.split("/")[0])
              let mes_inicio = parseInt(encabezado.periodo_inicio.split("/")[1]);
              let anio_inicio = parseInt(encabezado.periodo_inicio.split("/")[2]);
              let dia_fin = parseInt(encabezado.periodo_fin.split("/")[0]);
              let mes_fin = parseInt(encabezado.periodo_fin.split("/")[1]);
              let anio_fin = parseInt(encabezado.periodo_fin.split("/")[2]);
              // var date = new Date();
              let primerDia = new Date(anio_inicio, mes_inicio - 1, 1);
              let ultimoDia = new Date(anio_inicio, mes_inicio, 0);
              primerDia = primerDia.getDate();
              ultimoDia = ultimoDia.getDate();

              if ((mes_inicio === mes_declaracion && anio_inicio === anio) && (mes_fin === mes_declaracion && anio_inicio === anio_fin) && (dia_inicio === primerDia && dia_fin === ultimoDia)) {
                worksheet.A1 = "nit_retenidor";
                worksheet.A2 = "";
                worksheet.A3 = "";
                worksheet.A4 = "";
                worksheet.A5 = "";
                worksheet.B3 = "";
                worksheet.B4 = "";
                worksheet.B5 = "";
                worksheet.C4 = "";
                worksheet.D3 = "";
                worksheet.D4 = "";
                worksheet.E3 = "";
                worksheet.E4 = "";
                worksheet.F4 = "";
                worksheet.B1 = "nombre_retenedor";
                worksheet.C1 = "estado_constancia";
                worksheet.D1 = "constancia";
                worksheet.E1 = "fecha_emision";
                worksheet.F1 = "total_factura";
                worksheet.G1 = "importe_neto";
                worksheet.H1 = "afecto_retencion";
                worksheet.I1 = "total_retencion";
                let datas = XLSX.utils.sheet_to_json(worksheet);
                datas = datas.reverse();
                let registros = [];
                datas.forEach((x, i) => {
                  if ((i + 1) <= encabezado.total_constancias) {
                    registros.push({
                      nit_retenedor: x[""],
                      nombre_retenedor: x._1,
                      estado_constancia: x._2,
                      constancia: x._3,
                      fecha_emision: x._4,
                      total_factura: x._5,
                      importe_neto: x._6,
                      afecto_retencion: x._7,
                      total_retencion: x._8,
                    });
                  }
                });
                let obj = {
                  encabezado: encabezado,
                  tipo: self.tipo,
                  registros: registros,
                  archivo: file
                }
                // self.$emit('archivo', file);
                self.$emit('registro2', obj);
              } else {
                self.$toast.error(
                  "El rango de fecha debe ser de un mes COMPLETO, NO de varios meses y NI de ciertos días, verifica tu archivo " + file.name + " y vuelve a cargar"
                  , { timeout: 7000 });
              }
            } catch (error) {
              self.$toast.error(
                "El documento " + file.name + " no parece ser de un reporte de retenciones, verifica el nombre de tu archivo " + file.name
                , { timeout: 7000 });
            }
          } else if (self.tipo === -2) {//RETENCIONES
            console.log('Attachment.self.tipo === -2 - paso_3-isr');

            let fecha_solicitada = self.data.fecha;
            fecha_solicitada = fecha_solicitada.split("-");
            let mes = parseInt(fecha_solicitada[1]);
            let mes_declaracion = mes - 1;
            let anio = parseInt(fecha_solicitada[0])
            mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio *2: " + anio);

            try {
              let encabezado = {
                periodo_inicio: worksheet.B3.w,
                periodo_fin: worksheet.E3.h,
                nit_retenido: worksheet.B4.v,
                nombres_contribuyente: (worksheet.D4.h).split(", ")[0],
                apellidos_contribuyente: (worksheet.D4.h).split(", ")[1],
                usuario: worksheet.F4.v,
                total_constancias: parseInt(worksheet.B5.h),
              };
              let dia_inicio = parseInt(encabezado.periodo_inicio.split("/")[0])
              let mes_inicio = parseInt(encabezado.periodo_inicio.split("/")[1]);
              let anio_inicio = parseInt(encabezado.periodo_inicio.split("/")[2]);
              let dia_fin = parseInt(encabezado.periodo_fin.split("/")[0]);
              let mes_fin = parseInt(encabezado.periodo_fin.split("/")[1]);
              let anio_fin = parseInt(encabezado.periodo_fin.split("/")[2]);
              let primerDia = new Date(anio_inicio, mes_inicio - 1, 1);
              let ultimoDia = new Date(anio_inicio, mes_inicio, 0);
              primerDia = primerDia.getDate();
              ultimoDia = ultimoDia.getDate();

              if ((mes_inicio === mes_declaracion && anio_inicio === anio) && (mes_fin === mes_declaracion && anio_inicio === anio_fin) && (dia_inicio === primerDia && dia_fin === ultimoDia)) {
                worksheet.A1 = "nit_retenidor";
                worksheet.A2 = "";
                worksheet.A3 = "";
                worksheet.A4 = "";
                worksheet.A5 = "";
                worksheet.B3 = "";
                worksheet.B4 = "";
                worksheet.B5 = "";
                worksheet.C4 = "";
                worksheet.D3 = "";
                worksheet.D4 = "";
                worksheet.E3 = "";
                worksheet.E4 = "";
                worksheet.F4 = "";
                worksheet.B1 = "nombre_retenedor";
                worksheet.C1 = "estado_constancia";
                worksheet.D1 = "constancia";
                worksheet.E1 = "fecha_emision";
                worksheet.F1 = "total_factura";
                worksheet.G1 = "renta_imponible";
                worksheet.H1 = "total_retencion";
                let datas = XLSX.utils.sheet_to_json(worksheet);
                datas = datas.reverse();
                let registros = [];
                datas.forEach((x, i) => {
                  if ((i + 1) <= encabezado.total_constancias) {
                    registros.push({
                      nit_retenedor: x[""],
                      nombre_retenedor: x._1,
                      estado_constancia: x._2,
                      constancia: x._3,
                      fecha_emision: x._4,
                      total_factura: x._5,
                      renta_imponible: x._6,
                      total_retencion: x._7,
                    });
                  }
                });
                let obj = {
                  encabezado: encabezado,
                  tipo: self.tipo,
                  registros: registros,
                  archivo: file
                }
                // self.$emit('archivo', file);
                self.$emit('registro2', obj);
              } else {
                self.$toast.error(
                  "El rango de fecha debe ser de un mes COMPLETO, NO de varios meses y NI de ciertos días, verifica tu archivo " + file.name + " y vuelve a cargar"
                  , { timeout: 7000 });
              }
            } catch (error) {
              self.$toast.error(
                "El documento " + file.name + " no parece ser de un reporte de retenciones, verifica el nombre de tu archivo " + file.name
                , { timeout: 7000 });
            }
          } else if (self.tipo === 3) {//FACTURAS RECIBIDAS *Compras
            console.log("Attachment.self.tipo === 3 - paso_1");

            let registroErroneos = [];
            let registro = [];
            let fecha_solicitada = self.data.fecha;
            fecha_solicitada = fecha_solicitada.split("-");
            let mes = parseInt(fecha_solicitada[1]);
            let mes_declaracion = mes - 1;
            let anio = parseInt(fecha_solicitada[0])
            try {
              mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio *3: " + anio);
            } catch (error) {
              console.log(error);
              self.$toast.error("Ha ocurrido un error!", { timeout: 5000 });
              return;
            }

            try {
              datas.forEach(async x => {
                let fecha_emision = x['Fecha de emisión'] || x['Fecha de emisiÃ³n']
                fecha_emision = (fecha_emision.split("T"))[0];
                let mes_emision = parseInt((fecha_emision.split("-"))[1]);
                let anio_emision = parseInt((fecha_emision.split("-"))[0]);
                if (mes_emision === mes_declaracion && anio_emision === anio) {
                  let anulado = x["Marca de anulado "]
                  if (anulado == undefined) {
                    anulado = x['Marca de anulado']
                  }
                  let monto = 0;
                  if (x['Moneda'] == 'USD') {
                    await this.cambiodemoneda(fecha_emision);
                    monto = parseFloat(x['Monto (Gran Total)']) * this.pivote_dolares;
                    monto = parseFloat(monto).toFixed(2)
                  } else {
                    monto = x['Monto (Gran Total)']
                  }
                  let petroleo = 0;
                  if (x['Petróleo (monto de este impuesto)'] != undefined) {
                    petroleo = x['Petróleo (monto de este impuesto)'];
                  } else {
                    petroleo = x['PetrÃ³leo (monto de este impuesto)'];
                  }
                  registro.push({
                    fecha_emision: x['Fecha de emisión'] || x['Fecha de emisiÃ³n'],
                    numero_autorizacion: x['Número de Autorización'] || x['NÃºmero de AutorizaciÃ³n'],
                    tipo_dte: x['Tipo de DTE (nombre)'],
                    serie: x['Serie'],
                    numero_dte: x['Número del DTE'] || x['NÃºmero del DTE'],
                    nit_emisor: x['NIT del emisor'],
                    nombre_emisor: x['Nombre completo del emisor'],
                    codigo_establesimiento: x['Código de establecimiento'] || x['CÃ³digo de establecimiento'],
                    nombre_establesimiento: x['Nombre del establecimiento'],
                    nit_receptor: x['ID del receptor'],
                    nombre_receptor: x['Nombre completo del receptor'],
                    nit_certificador: x['NIT del Certificador'],
                    nombre_certificador: x['Nombre completo del Certificador'],
                    moneda: x['Moneda'],
                    monto: monto,
                    anulado: anulado,
                    monto_iva: x['IVA (monto de este impuesto)'],
                    monto_petroleo: petroleo,
                    monto_turismo_hospedaje: x['Turismo Hospedaje (monto de este impuesto)'],
                    monto_turismo_pasajes: x['Turismo Pasajes (monto de este impuesto)'],
                    monto_timbre_prensa: x['Timbre de Prensa (monto de este impuesto)'],
                    monto_bomberos: x['Bomberos (monto de este impuesto)'],
                    monto_tasa_municipal: x['Tasa Municipal (monto de este impuesto)'],
                    monto_bebidas_alcoholicas: x['Bebidas alcohólicas (monto de este impuesto)'] != undefined ? x['Bebidas alcohólicas (monto de este impuesto)'] : x['Bebidas alcohÃ³licas (monto de este impuesto)'],
                    monto_tabaco: x['Tabaco (monto de este impuesto)'],
                    monto_cemento: x['Cemento (monto de este impuesto)'],
                    monto_bebidas_no_alcoholicas: x['Bebidas no Alcohólicas (monto de este impuesto)'] != undefined ? x['Bebidas no Alcohólicas (monto de este impuesto)'] : x['Bebidas no AlcohÃ³licas (monto de este impuesto)'],
                    monto_tarifa_portuaria: x['Tarifa Portuaria (monto de este impuesto)'],
                    fila: fila + 1
                  })
                } else {
                  self.$toast.info("Atención en el archivo " + file.name + ", la fecha de emisión de la factura en la línea " + (fila + 1) + " , no coincide con la fecha del período a presentar", { timeout: 10000, showCloseButtonOnHover: true, })
                  registroErroneos.push(fila);
                }
                fila++;
              });
            } catch (error) {
              self.$toast.error("Este archivo " + file.name + " no es válido, para la carga de facturas", { timeout: 5000 });
              return;
            }

            console.log('*** xxx ***');

            if (registroErroneos.length > 0) {
              console.log('*** if ***');
              self.$toast.error("Por favor verifica el archivo de excel " + file.name + " y vuelve a ingresar de nuevo", { timeout: 10000 });
              registro = []
              return;
            } else {
              console.log('*** else ***');
              self.$emit('registro', { registros: registro, tipo: self.tipo, archivo: file });
            }

            console.log('*** xxx ***');

          } else if (self.tipo === 4) {// CARGA DE RETENEDORES
            console.log("Attachment.self.tipo === 4");
            let contador = 0;
            let retenedores = [];
            datas.forEach(element => {

              let fechaExcel = element.FECHA;
              let fechaBase = new Date(1900, 0, 1); // Excel base date
              let fechaJS = new Date(fechaBase.getTime() + (fechaExcel - 2) * 24 * 60 * 60 * 1000); // Ajuste de días
              let fechaFormateada = fechaJS.toLocaleDateString('es-ES');
              let fecha_forma = fechaFormateada.split("/");
              retenedores.push({
                nit: element.NIT,
                nombre: element.NOMBRE,
                fecha: fecha_forma[2] + "/" + fecha_forma[1] + "/" + fecha_forma[0],
              })
            });
            self.$emit('registros', retenedores);
          } else if (self.tipo === 5) {//CARGA DE NIT - TIPOS DE EMISORES
            console.log("Attachment.self.tipo === 5");
            let data_cleaned = [];
            let errors = [];
            try {
              datas.forEach(element => {
                let obj = {
                  nit: "",
                  tipo_emisor_id: this.carga_tipo_emisor.id,
                  nombre: "",
                  grupo: "",
                };
                // recorre el elemento para obtener los datos
                for (const key in element) {
                  if (key.includes('Nombre comercial')) obj.nombre = element[key];
                  if (key.includes('NIT')) obj.nit = element[key];
                  if (key.includes('Grupo_1')) obj.grupo = element[key];
                }
                if (obj.grupo == this.carga_tipo_emisor.grupo) {
                  data_cleaned.push(obj);
                } else {
                  errors.push(obj);
                }
              });
              self.$emit('registro', data_cleaned, errors);
            } catch (error) {
              console.log(error);
              self.$toast.error(
                "NO ES POSIBLE CARGAR ESTE ARCHIVO"
              );
            }
          } else if (self.tipo === 6) {//CARGA DE clientes gestores
            console.log("Attachment.self.tipo === 6");
            let data_cleaned = [];
            let errors = [];
            try {
              console.log("datas", datas);
              this.$emit('clientes', datas);
            }
            catch (error) {
              console.log(error);
              self.$toast.error(
                "NO ES POSIBLE CARGAR ESTE ARCHIVO"
              );
            }
          } else if (self.tipo === 7) {//CARGA DE sociedades anónimas
            console.log("Attachment.self.tipo === 7");
            let data_cleaned = [];
            let errors = [];
            try {
              console.log("datas", datas);
              this.$emit('sociedades', datas);
            }catch (error) {
              console.log(error);
              self.$toast.error(
                "NO ES POSIBLE CARGAR ESTE ARCHIVO"
              );
            }             
          }else {
            self.$toast.error(
              "EL DOCUMENTO INGRESADO ES INVALIDO"
            );
          }
        };
      } catch (error) {
        self.$toast.error(
          "Los archivos deben ser de excel (.xlsx ó .xls)"
        );
        return;
      }
      reader.readAsArrayBuffer(file);
    },
    async enviarDato(file, attachment) {
      console.log('enviarDato');
      this.$emit("archivo", file, attachment, this.index, this.folios, this.base64)
    },
    sendingFiles(files) {
      console.log('sendingFiles');
    },
    uploadProgress(file, progress) {
      console.log('uploadProgress');
      this.tempAttachments.map(attachment => {
        if (attachment.title === file.name) {
          attachment.progress = `${Math.floor(progress)}`;
        }
      });
    },
    remover_archivo(index) {
      console.log('remover_archivo');
      this.tempAttachments = [];
      this.$emit("remover_archivo", index)
    },
  },
  computed: {
    getTempAttachments() {
      console.log('getTempAttachments');
      return this.tempAttachments;
    },
    getAttachments() {
      console.log('getAttachments');
      return this.attachments;
    },
  },
  async created() {
    console.log('_/Attachment');
  },
};